export const nodeRoleOptions = [
    { label: 'No Access', value: 0 },
    { label: 'User', value: 1 },
    { label: 'Admin', value: 5 },
    { label: 'Owner', value: 6 },
]

// TODO @ALAN: REVIEW THE VALUES
